module.exports = __webpack_public_path__ + "img/SSWS_Modern_Sword_Canonical.6261beff.png";